import { compareGroupMapper } from 'container/compareGroupMapper';

import { PieChartMapper } from '../mapper/PieChartMapper';

export const pieChartMapper = new PieChartMapper(compareGroupMapper);
